/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
import { FormProvider, useForm } from "react-hook-form";
import classnames from "classnames";

// Components
import SkeletonContent from "components/molecules/SkeletonContent";
import CarouselBannersDesktop from "components/molecules/CarouselBannersDesktop";
import GameSortAndFilter from "components/organisms/GameSortAndFilter";
import GameFormSearch from "components/molecules/GameFormSearch";

// Containers
import FavoriteGameListContainer from "containers/organisms/FavoriteGameListContainer";
import GameSortDesktopContainer from "containers/organisms/GameSortDesktopContainer";
import GameSearchListContainer from "containers/molecules/GameSearchListContainer";

// Hooks
import useTranslate from "hooks/useTranslate";
import { useBreakpoint } from "hooks/useBreakpoint";

// Images
import emptyPageGlory from "assets/images/glory/favorites_empty_glory.webp";
import emptyPageBanger from "assets/images/banger/robot_faworite_games.webp";

// Types
import { GameType } from "types/Games";

import "./styles.sass";

type FavoritePageProps = {
  favorites: GameType[] | undefined;
  isLoading: boolean;
};

const FavoritePage = (props: FavoritePageProps) => {
  const { favorites, isLoading } = props;
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const { isDesktop } = useBreakpoint();
  const methods = useForm();
  const t = useTranslate();
  const emptyImage =
    VITE_APP_PROJECT_NAME === "glory" ? emptyPageGlory : emptyPageBanger;

  const searchQuery = methods.watch("search");

  const classNameImage = classnames("FavoritePage-empty-img", {
    "FavoritePage-empty-img_banger": VITE_APP_PROJECT_NAME === "banger",
  });

  return (
    <>
      <CarouselBannersDesktop />
      <FormProvider {...methods}>
        <div className="FavoritePage">
          <div className="FavoritePage__filter">
            {!isDesktop && <GameSortAndFilter />}
            {isDesktop && (
              <>
                <GameFormSearch />
                <GameSortDesktopContainer />
              </>
            )}
          </div>
          <div className="FavoritePage__header">
            <div className="FavoritePage__header_title">
              {t(
                searchQuery && searchQuery.length > 0
                  ? "casino.search.title"
                  : "casino.sidebar.favorite",
              )}
            </div>
          </div>
          {searchQuery && searchQuery.length > 0 ? (
            <GameSearchListContainer />
          ) : (
            <>
              {isLoading ? (
                <SkeletonContent />
              ) : favorites && !!favorites.length ? (
                <FavoriteGameListContainer />
              ) : (
                <div className="FavoritePage-empty">
                  <div className={classNameImage}>
                    <img src={emptyImage} alt="empty" />
                  </div>
                  <span className="FavoritePage-empty__title">
                    {t("casino.favorite.description1")}
                  </span>
                  <span className="FavoritePage-empty__desc">
                    {t("casino.favorite.text")}
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      </FormProvider>
    </>
  );
};

export default FavoritePage;
